<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserMenu',
})
</script>
<template>
    <div class="user-wrapper">
        <div class="content-box">
            <!-- 👇 审核任务中心入口 -->
            <!--
            <span @click="showAuditCenter" class="action ant-dropdown-link user-dropdown-menu"
                style="margin-right: 20px; cursor: pointer;">
            <div class="audit-badge-wrap">
                <a-badge class="audit-badge" color="#1677ff" :count="auditTotal" :overflow-count="99" title="审核任务中心">
                    <AuditOutlined style="font-size: 20px; color: #4e5969;" />
                </a-badge>
            </div>
            </span>
            -->
            <!-- 电话拨号 -->
            <span @click="showPhoneCall" class="action ant-dropdown-link user-dropdown-menu"
                style="margin-right: 20px; cursor: pointer;">
                <PhoneOutlined style="font-size: 20px; color: #4e5969;" title="电话拨号"></PhoneOutlined>
            </span>

            <!-- 消息中心（保持原样） -->
            <span @click="showInform" class="action ant-dropdown-link user-dropdown-menu"
                style="margin-right: 20px; cursor: pointer;">
                <a-badge color="#1677ff" :count="state.unreadNum">
                    <BellOutlined style="font-size: 20px; color: #4e5969;" title="消息中心" />
                </a-badge>
            </span>

            <!-- 用户头像下拉 -->
            <a-dropdown>
                <span class="action ant-dropdown-link user-dropdown-menu" style="cursor: pointer;">
                    <a-avatar class="avatar" :src="$store.state.user.image_domain + filingsInfo.wechat_picture"
                        v-if="filingsInfo?.wechat_picture && $store.state.user.image_domain" />
                    <a-avatar class="avatar" v-else>
                        <template #icon>
                            <UserOutlined />
                        </template>
                    </a-avatar>
                    <span class="nickname">{{ UserInfo.nickname }}</span>
                </span>
                <template #overlay>
                    <a-menu class="user-dropdown-menu-wrapper">
                        <a-menu-item key="4" @click="showSystemSetting">
                            <a>
                                <SettingOutlined />
                                <span>系统设置</span>
                            </a>
                        </a-menu-item>
                        <a-menu-item key="4" v-if="isAdminJump">
                            <a href="javascript:;" @click="handleBackAdmin">
                                <RollbackOutlined />
                                <span>返回admin</span>
                            </a>
                        </a-menu-item>
                        <a-menu-divider />
                        <a-menu-item key="3">
                            <a href="javascript:;" @click="handleLogout">
                                <LogoutOutlined />
                                <span>退出登录</span>
                            </a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
        </div>
    </div>

    <NewsInfo v-if="state.showInfo" :detailData="state.detailData" @cancel="onOk" @ok="onOk"></NewsInfo>

    <AuditCenterDrawer v-model:open="showAuditDrawer" :total="auditTotal" @refresh="loadAuditCount"
        @update:total="(val) => auditTotal = val" />
</template>

<script lang="ts" setup name="UserMenu">
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import {
    SettingOutlined,
    LogoutOutlined,
    LockOutlined,
    RollbackOutlined,
    UserOutlined,
    BellOutlined,
    PhoneOutlined,
    AuditOutlined,
} from '@ant-design/icons-vue'
import { systemConfig } from '@/store/reactiveState'
import ls from '@/utils/Storage'
import { useRouter } from 'vue-router'
import store from '@/store'
import { loginSuccess } from '@/views/user/helper'
import NewsInfo from '@/components/InformDrawer/components/NewsInfo.vue'
import AuditCenterDrawer from "./AuditCenterDrawer.vue"
import { reactive, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

const router = useRouter()
const $store = useStore()
const props = defineProps(['theme'])

const UserInfo = ls.get('USER_INFO') || {}
const isAdminJump = ls.get('login_success_flag')
const filingsInfo = ls.get('FILINGS_INFO') || {}

/* ========== 审核任务中心相关 ========== */
const auditTotal = ref(128) // 初始假数据
const showAuditDrawer = ref(false)

const showAuditCenter = () => {
    showAuditDrawer.value = true
}

const loadAuditCount = () => { }
/* ====================================== */

const handleLogout = () => {
    Modal.confirm({
        title: '提示',
        content: '确定注销登录吗 ?',
        onOk: () => {
            store.dispatch('Logout', router).then((res) => {
                router.push({ path: '/user/login', query: { redirect: router.currentRoute.value.fullPath } })
            }).catch((res) => { })
        },
        onCancel() { }
    })
}

const showSystemSetting = () => {
    systemConfig.commit('SET_SETTING_DRAWER', true)
}

const showInform = () => {
    $store.commit('SET_SHOW_INFORM', true)
}

const handleBackAdmin = () => {
    $store.dispatch('SwitchUser', 'back' + isAdminJump).then((res) => {
        $store.dispatch('GetInfo')
        loginSuccess(router, res)
        ls.set('login_success_flag', 0)
        setTimeout(() => { window.location.href = '/' })
    }).catch((res) => {
        message.error(res.msg)
    })
}

interface state {
    unreadNum: number
    showInfo: boolean
    detailData: any
}
const state = reactive<state>({
    unreadNum: 0,
    showInfo: false,
    detailData: {}
})

onMounted(() => {
    initUnreadNum()
    gitNewsPop(0)
    loadAuditCount()
})

const initUnreadNum = () => {
    let requestParam = { url: '/admin/v1/userHeadInfo', method: 'post', data: {} }
    baseService(requestParam).then((res: any) => {
        state.unreadNum = res.data.unreadNum
    }).catch((res) => { })
}

const gitNewsPop = (read_news_id: any) => {
    let requestParam = { url: '/admin/v1/news/headPop', method: 'post', data: { read_news_id: read_news_id } }
    baseService(requestParam).then((res: any) => {
        if (res.data) {
            state.detailData = res.data
            state.showInfo = true
        }
    })
}

const onOk = () => {
    state.showInfo = false
    gitNewsPop(state.detailData.id)
}

const showPhoneCall = () => {
    $store.dispatch('usbphone/ShowPhoneModal')
}
</script>

<style lang="less" scoped>
.content-box {
    display: flex;
    align-items: center;
}

/* 保持原有的点击交互 */
.action {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

/* 👇 微调 2：给壳子右边留出 10px 的物理空间，防止切边 */
.audit-badge-wrap {
    padding: 2px 10px 0 0;
}

/* 👇 微调 3：让角标自己向左收进 2px，配合右侧留白 */
.audit-badge :deep(.ant-badge-count) {
    right: -2px !important;
}
</style>

<style lang="less">
.user-dropdown-menu-wrapper {
    .ant-dropdown-menu-item {
        width: 100% !important;
    }
}
</style>
